export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}

export function validateMobile(mobile) {
  const mobileRegex = /^[6-9]\d{9}$/; // Assumes 10-digit Indian mobile numbers starting with 6-9
  return mobileRegex.test(mobile.trim());
}

export function validateText(text, minLength = 1, maxLength = 255) {
  const textRegex = /^[a-zA-Z\s]+$/; // Allows only letters and spaces
  return text.trim().length >= minLength && text.trim().length <= maxLength && textRegex.test(text.trim());
}

export function validateCity(city) {
  const cityRegex = /^[a-zA-Z\s]+(?:[\s-][a-zA-Z\s]+)*$/; // Allows letters, spaces, and hyphens
  return cityRegex.test(city.trim());
}
export function capitalizeText(text) {
    if (!text) return "";
    
    // Trim leading/trailing spaces and remove special characters at the start
    text = text.trimStart()
    .replace(/[^a-zA-Z\s]/g, "")// Remove all non-alphabetic characters except spaces
    .replace(/\s+/g, " ") // Replace multiple spaces with a single space

   
    return text
      .split(" ") // Split by spaces, preserving empty spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Rejoin with spaces
  }
export function formatRupees(amount) {
    
    // Convert to number and handle invalid inputs
    // const num = Math.round(Number(amount) || 0);
    const num = Math.round(Number(String(amount).replace(/,/g, '')) || 0);
    // console.log('amount',amount,num);
  
    // Format in Indian numbering system
    return `₹${num.toLocaleString("en-IN")}`;
  }

  export const roundNumber = (num) => {
    return Math.round(num);
  };


  export const moneyFormatIndia = (num) => {
    if (!num) return "0";
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(Math.round(num));
  };

// 🛠️ Helper function
export function calculateTotalFloat(value) {
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}


  
  
  
  